import React, { useState } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//import { format } from 'date-fns';
//import DateRangePicker from 'react-daterange-picker';
//import moment from 'moment';
//import 'react-daterange-picker/dist/css/react-calendar.css' // For some basic styling. (OPTIONAL)


export default function DateRangePickerScreen() {

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());

    return (
        <div className="container-fluid">
            <div>Date Range Picker</div>

            <DatePicker 
                showTimeSelect
                dateFormat="yyyy-MM-dd HH.mm.ss.s" //MMMM d, yyyy h:mmaa
                selected={startDate} 
                selectsStart 
                startDate={startDate}
                endDate={endDate} 
                onChange={date => {
                    setStartDate(date);
                    //console.log('>>> Start Date (formatted): ', format(date, 'yyyy-MM-dd HH.mm.ss.s'));
                    }} 
            />
            <DatePicker 
                showTimeSelect 
                dateFormat="yyyy-MM-dd HH.mm.ss.s" //MMMM d, yyyy h:mmaa
                selected={endDate} 
                selectsEnd 
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                onChange={date => setEndDate(date)}
            />
            
        </div>
    );

}